"use strict";

function getTopics($modal) {
    var topics = [];

    $modal.find(".js-login-consent-topic").each(function () {
        var $topic = $(this);

        topics.push({
            topic_id: String($topic.data("topic-id")),
            selected: $topic.prop("checked")
        });
    });

    return topics;
}

function showError($modal, message) {
    $modal.find(".js-login-consent-error")
        .text(message || $modal.data("error-message"))
        .removeClass("d-none");
}

function showSuccess($modal) {
    var $success = $modal.find(".js-login-consent-success");
    var $successTitle = $success.find(".js-login-consent-success-title");

    $modal.find(".js-login-consent-form")
        .addClass("d-none")
        .attr("aria-hidden", "true");
    $success
        .removeClass("d-none")
        .attr("aria-hidden", "false");
    $modal.attr("aria-labelledby", $successTitle.attr("id"));
    $successTitle.trigger("focus");
}

function bindModal($modal) {
    var $form = $modal.find(".js-login-consent-form");
    var saved = false;

    $form.on("submit", function (event) {
        var formElement = $form.get(0);
        var $submitButton = $form.find(".js-login-consent-submit");
        var formData;

        event.preventDefault();
        $modal.find(".js-login-consent-error").addClass("d-none").text("");

        if (formElement && !formElement.checkValidity()) {
            formElement.reportValidity();
            return;
        }

        formData = $form.serializeArray();
        formData.push({
            name: "topics",
            value: JSON.stringify(getTopics($modal))
        });

        $submitButton.prop("disabled", true);

        $.ajax({
            url: $form.attr("action"),
            method: "POST",
            data: $.param(formData),
            dataType: "json"
        }).done(function (response) {
            if (!response || !response.success) {
                showError($modal, response && response.message);
                return;
            }

            saved = true;
            showSuccess($modal);
        }).fail(function (xhr) {
            var response = xhr.responseJSON || {};

            showError($modal, response.message);
        }).always(function () {
            $submitButton.prop("disabled", false);
        });
    });

    $modal.on("hidden.bs.modal", function () {
        if (!saved) {
            $.ajax({
                url: $form.data("dismiss-url"),
                method: "POST",
                data: $form.serialize(),
                dataType: "json"
            });
        }

        $modal.remove();
    });
}

function loadPrompt() {
    var $launcher = $(".js-login-consent-launcher").first();

    if (!$launcher.length) {
        return;
    }

    $.ajax({
        url: $launcher.data("check-url"),
        method: "GET",
        dataType: "html"
    }).done(function (html) {
        var markup = $.trim(html || "");
        var $modal;

        if (!markup) {
            return;
        }

        $("body").append(markup);
        $modal = $(".js-login-consent-modal").last();
        bindModal($modal);
        $modal.modal("show");
    }).always(function () {
        $launcher.remove();
    });
}

module.exports = {
    loadPrompt: loadPrompt
};
